import { FC } from 'react'
import { Box, styled, Typography } from '@mui/material'
import { SortHeader } from '@/components/table/SortHeader'
import type { TableColumn } from '@/utilities/types/table'
import { FilterState } from '@/utilities/types/filters'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  background: '#EFF0F4',
  fontFamily: 'Gabarito',
  fontWeight: 700,
  fontSize: 14,
  textTransform: 'uppercase',
  borderBottom: '1px solid #e0e0e0',
  position: 'sticky',
  top: 0,
  zIndex: 2,
  borderRadius: '8px',
}))

const HeaderText = styled(Typography)(({ theme }) => ({
  color: '#505470',
  fontFamily: 'Gabarito',
  fontWeight: 700,
  fontSize: '14px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}))

interface TableHeaderProps<T = any> {
  columns: TableColumn[]
  filterState: FilterState<T>
  handleSort?: (sort: string) => void
}

export const TableHeader: FC<TableHeaderProps> = ({
  columns,
  filterState,
  handleSort,
}) => {
  return (
    <Box padding="16px" sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
      <HeaderContainer>
        {columns.map((column) => {
          if (column.id === 'currentLayer') {
            return (
              <Box
                key={column.id}
                sx={{
                  width: column.width,
                  flexShrink: 0,
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxSizing: 'border-box',
                  minWidth: 0,
                }}
              >
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto 1fr',
                    alignItems: 'center',
                    gap: 0.5,
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      color: '#4e506d',
                    }}
                  >
                    <HeaderText>Current</HeaderText>
                    <HeaderText>Assignee</HeaderText>
                  </Box>

                  <ArrowRightAltIcon
                    sx={{ fontSize: '1rem', color: 'text.secondary' }}
                  />

                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      color: '#4e506d',
                    }}
                  >
                    <HeaderText>Next</HeaderText>
                    <HeaderText>Assignee</HeaderText>
                  </Box>
                </Box>
              </Box>
            )
          }

          return (
            <Box
              key={column.id}
              sx={{
                width: column.width,
                flexShrink: 1,
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: column.sortable ? 'pointer' : 'default',
                textAlign: 'center',
                boxSizing: 'border-box',
                minWidth: 0,
              }}
            >
              <SortHeader
                label={column.label}
                field={column.id}
                currentSort={filterState.sort}
                handleSort={handleSort ?? (() => {})} // fallback to no-op
                sortable={column.sortable}
              />
            </Box>
          )
        })}
      </HeaderContainer>
    </Box>
  )
}
